import type {
  BulkAccessPreview,
  BulkAccessTarget,
} from '~/features/access-control/types/AccessControl';

import { previewDocumentBulkAccessForRequest } from '~/features/access-control/mocks/accessControlMockStore';
import { withAccessControlMockFallback } from '~/features/access-control/mocks/withAccessControlMockFallback';
import { pilot } from '~/services/serviceInstances';

import type { ServerBulkAccessPreview } from './bulkAccessMapper';

import {
  mapBulkAccessPreviewRequest,
  mapBulkAccessPreviewResponse,
} from './bulkAccessMapper';

type Request = {
  targets: BulkAccessTarget[];
  selectAll?: boolean;
  folderId?: string;
};

export const getBulkAccessPreview = async ({
  targets,
  selectAll,
  folderId,
}: Request): Promise<BulkAccessPreview> => {
  return withAccessControlMockFallback(
    async () => {
      const serverResponse = await pilot.post<ServerBulkAccessPreview>(
        '/access/bulk/preview/',
        mapBulkAccessPreviewRequest({ targets, selectAll, folderId }),
      );

      return mapBulkAccessPreviewResponse(serverResponse);
    },
    () => previewDocumentBulkAccessForRequest({ targets, selectAll, folderId }),
  );
};
